import * as types from 'models/actionTypes'
import {
    DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE,
    DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS,
    ORIENTATION_LANDSCAPE,
} from 'models/ui/constants'

const initialState = {
    compositionsOpen: false,
    scenesOpen: false,
    artOpen: true,
    designSidepanelOpen: false,
    designSidepanelMode: DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE,
    shouldPresentItemSelection: false,
    artTrayFilter: null,
    shouldShowWelcomePopup: false,
    sceneSelectionTabShowStock: false,
    sharePanelOpen: false,
    filterModalOpen: false,
    showSwapMenu: false,
    showMissingWallsModal: false,
    showLoginPromptModal: false,
    orientation: ORIENTATION_LANDSCAPE,
    showDesignSummary: false,
}

const ui = (state = initialState, action) => {
    switch (action.type) {
        case types.COMPOSITIONS_TOGGLE:
            return {
                ...state,
                compositionsOpen: !state.compositionsOpen,
            }
        case types.SCENES_TOGGLE:
            return {
                ...state,
                scenesOpen: !state.scenesOpen,
            }
        case types.SCENES_OPEN:
            return {
                ...state,
                scenesOpen: true,
            }
        case types.ART_TOGGLE:
            return {
                ...state,
                artOpen: !state.artOpen,
            }
        case types.OPEN_DESIGN_SIDEPANEL: {
            const newState = {
                ...state,
                designSidepanelOpen: true,
            }
            if (action.renderItemId) {
                newState.designSidepanelMode = DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS
            }
            return newState
        }
        case types.CLOSE_DESIGN_SIDEPANEL:
            return {
                ...state,
                designSidepanelOpen: false,
            }
        case types.SET_DESIGN_SIDEPANEL_MODE:
            return {
                ...state,
                designSidepanelMode: action.mode,
            }
        case types.SET_ADMIN:
            if (!action.shouldBeAdmin) {
                return {
                    ...state,
                    designSidepanelMode: DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE,
                }
            }
            return {
                ...state,
            }
        case types.PRESENT_ITEM_SELECTION:
            return {
                ...state,
                shouldPresentItemSelection: action.shouldPresent,
            }
        case types.ART_TRAY_FILTER:
            return {
                ...state,
                artTrayFilter: action.filter,
            }
        case types.ITEM_SELECTION_DISPLAY:
            return {
                ...state,
                itemSelectionDisplay: action.display,
            }
        case types.RECEIVE_USER:
            return {
                ...state,
                shouldShowWelcomePopup: action.userData.isFirstTime || false,
            }
        case types.CLOSE_WELCOME_POPUP:
            return {
                ...state,
                shouldShowWelcomePopup: false,
            }
        case types.SELECT_SCENE_SELECTION_TAB:
            return {
                ...state,
                sceneSelectionTabShowStock: action.shouldShowStock,
            }
        case types.SHARE_PANEL_OPEN_TOGGLE:
            return {
                ...state,
                sharePanelOpen: !state.sharePanelOpen,
            }
        case types.SET_FILTER_MODAL_OPEN:
            return {
                ...state,
                filterModalOpen: action.isOpen,
            }
        case types.SHOW_SWAP_MENU:
            return {
                ...state,
                showSwapMenu: action.showSwapMenu,
            }
        case types.SHOW_MISSING_WALLS_MODAL:
            return {
                ...state,
                showMissingWallsModal: action.showMissingWallsModal,
            }
        case types.SET_MOBILE_ORIENTATION:
            return {
                ...state,
                orientation: action.orientation,
            }
        case types.LOGIN_NEEDED:
            return {
                ...state,
                showLoginPromptModal: true,
            }
        case types.SHOW_LOGIN_PROMPT_MODAL:
            return {
                ...state,
                showLoginPromptModal: action.showLoginPromptModal,
            }

        case types.SHOW_DESIGN_SUMMARY:
            return {
                ...state,
                showDesignSummary: action.showDesignSummary,
            }
        default:
            return state
    }
}

export default ui
